<template>
  <div>
    <el-dialog :title="title"
               :visible.sync="dialogFormVisible"
               width="400px"
               top="10px"
               @close="handleClose()"
               @open="open()">
      <div class="auditContent">
        <div class="iframContent">
          <iframe :src="currentSrc"
                  width="300px"
                  frameborder="1"
                  style=" border: 1px solid black;"
                  height="600px"
                  @load="handleIframeLoad"></iframe>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    noteId: {
      type: Number,
      default: () => {
        return null
      },
    },
    rowDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    type: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  data() {
    return {
      currentSrc: '',
      dialogFormVisible: this.isVisible,
      title: '查看笔记',
    }
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
  },
  methods: {
    handleIframeLoad() {},
    handleClose() {
      this.currentSrc = ''
      this.$emit('close')
      this.rowDetail = {}
    },
    open() {
      if (this.rowDetail.uid) {
        this.title = '查看主页'
        if (location.host.includes('admin.kaoyanbox.com')) {
          this.currentSrc = `https://senior.kaoyanbox.com/#/graduatA/personHomePage/personHomePage?uid=${this.rowDetail.uid}`
        } else {
          this.currentSrc = `https://test-senior.kaoyanbox.net/#/graduatA/personHomePage/personHomePage?uid=${this.rowDetail.uid}`
        }
      } else if (this.type) {
        this.title = '预览'
        if (location.host.includes('admin.kaoyanbox.com')) {
          this.currentSrc = `https://senior.kaoyanbox.com/#/graduatA/themePage/themePage?id=${this.noteId}`
        } else {
          this.currentSrc = `https://test-senior.kaoyanbox.net/#/graduatA/themePage/themePage?id=${this.noteId}`
        }
      } else {
        if (location.host.includes('admin.kaoyanbox.com')) {
          this.currentSrc = `https://senior.kaoyanbox.com/#/graduatA/experienceDatail/index?id=${this.noteId}`
        } else {
          this.currentSrc = `https://test-senior.kaoyanbox.net/#/graduatA/experienceDatail/index?id=${this.noteId}`
        }
      }
    },
  },
}
</script>
<style scoped lang="less">
::v-deep .el-dialog__header {
  background: #ecf2fe;
}
.auditContent {
  width: 900px;
  display: flex;
  justify-content: space-between;
  padding-left: 32px;
}
</style>